// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectDropdown {
  background-color: white;
  border-color: #8aaed6;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  height: 40px;
  width: 200px;
}

.assessment-header-btn {
  border-radius: 5px;
  padding: 6px 25px;
  font-size: 12px;
}

.assessment-card {
  border: 1px solid #7ac7ff;
  background-color: #fafcff;
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./../assessment/src/components/QuestionPutTogetherCard/QuestionPutTogetherCard.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AACF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AAEF;;AACA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;AAEF","sourcesContent":[".selectDropdown {\n  background-color: white;\n  border-color: #8aaed6;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 3px;\n  height: 40px;\n  width: 200px;\n}\n.assessment-header-btn {\n  border-radius: 5px;\n  padding: 6px 25px;\n  font-size: 12px;\n}\n\n.assessment-card {\n  border: 1px solid #7ac7ff;\n  background-color: #fafcff;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
